import { axiosCreate } from "@config/index"
import { verifyBodyResponse } from "@thelpers/verifyBodyResponse"

export const getChargeInstanceDetail = async ({
    token,
    charge_instance_id,
    find_value,
    sort_order,
    sort_by,
    limit = 10,
    skip = 0
}) => {

    const params = {
        charge_instance_id,
        find_value,
        sort_order,
        sort_by,
        limit,
        skip
    }

    try {
        const res = await axiosCreate.get('/charge/instance/detail', {
            params,
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })

        return verifyBodyResponse(res, true)
    } catch (error) {
        console.error(error)
        return verifyBodyResponse(error, false)
    }
}